<template>
  <div id="page">
    <van-sticky>
      <div class="search-box">
        <van-search
          v-model="search"
          placeholder="拖动排序与搜索功能冲突，暂时屏蔽搜索" />
      </div>
    </van-sticky>
    <!-- 一级导航 -->
    <div class="nav-level1">
      <draggable
        :disabled="draggableLock"
        style="display: inline-block"
        :list="productData"
        group="nav1"
        @start="dragNav1 = true"
        @end="dragNav1 = false"
        :options="{ orientation: 'horizontal' }">
        <div
          class="nav-item-level1"
          v-for="(nav, index) in productData"
          :key="index"
          @click="
            navActiveLevel1 = index
            navObjLevel1 = nav
          "
          style="position: relative">
          <van-icon
            name="close"
            style="position: absolute; right: 5px; top: 5px"
            size="18px"
            color="red"
            @click.stop="delNav1(nav)"></van-icon>
          <img :src="nav.Img" loading="lazy" />
          <div :class="navActiveLevel1 === index ? 'selected' : ''">
            {{ nav.Title }}
          </div>
          <div @click="editNav1(nav)" style="color: blue">编辑</div>
        </div>
      </draggable>
      <div class="nav-item-level1" style="height: ">
        <van-button
          icon="plus"
          type="info"
          plain
          style="width: 100%; height: 100%"
          @click="editNav1()"></van-button>
      </div>
    </div>
    <!-- 内容 -->
    <div class="content">
      <van-row type="flex" style="height: 100%">
        <!-- 二级导航栏 -->
        <van-col span="5" class="navLevel2">
          <van-button icon="plus" @click="editNav2()">新增</van-button>
          <van-sidebar v-model="navActiveLevel2" v-if="navObjLevel1">
            <draggable
              :disabled="draggableLock"
              v-model="navObjLevel1.Items"
              group="nav2"
              @start="dragNav2 = true"
              @end="dragNav2 = false">
              <van-sidebar-item
                :title="nav.Title"
                v-for="(nav, index) in navObjLevel1.Items"
                :key="index">
                <div slot="title">
                  <span>{{ nav.Title }}</span>
                  <div style="font-size: 12px; font-weight: bold">
                    <a @click="editNav2(nav)" style="color: blue">编辑</a>
                    <a @click="delNav2(nav)" style="color: red; float: right"
                      >删除</a
                    >
                  </div>
                </div>
              </van-sidebar-item>
            </draggable>
          </van-sidebar>
        </van-col>
        <van-col span="19" class="product-list">
          <draggable
            :disabled="draggableLock"
            v-model="filterProducts"
            group="products"
            @start="drag = true"
            @end="drag = false">
            <product-item
              :model="item"
              v-for="(item, index) in filterProducts"
              :key="index"
              :visableShoppingCart="true">
              <div slot="shopping-cart">
                <van-button
                  type="primary"
                  size="mini"
                  color="#0166b8"
                  @click="edit(item)"
                  >编辑</van-button
                ><van-button type="danger" size="mini" @click="delProduct(item)"
                  >删除</van-button
                >
              </div>
            </product-item>
          </draggable>
          <div style="text-align: center">
            <van-button
              icon="plus"
              type="info"
              plain
              style="width: 100%"
              @click="edit()"
              >新增商品</van-button
            >
          </div>
        </van-col>
      </van-row>
    </div>
    <!-- 编辑对话框 -->
    <van-dialog
      v-model="visableEditDialog"
      :title="editProduct && editProduct.Id ? '编辑' : '新增'"
      show-cancel-button
      @confirm="editConfirm">
      <van-cell-group v-if="editProduct">
        <van-uploader
          v-model="editProductImgs"
          :max-count="1"
          :after-read="imgUpload" />
        <van-field
          v-model="editProduct.Title"
          label="名称"
          placeholder="请输入名称"
          required
          error />
        <van-field
          v-model="editProduct.Price"
          label="价格"
          placeholder="请输入价格"
          required
          type="number"
          error />
        <van-field
          v-model="editProduct.Label"
          label="小标签"
          placeholder="名称左侧小标签" />
      </van-cell-group>
    </van-dialog>

    <!-- 一级导航对话框 -->
    <van-dialog
      v-model="visableNav1Dialog"
      :title="editNav1Value && editNav1Value.Id ? '编辑' : '新增'"
      show-cancel-button
      @confirm="editNav1Confirm">
      <van-cell-group v-if="editNav1Value">
        <van-uploader
          v-model="editNavImgs"
          :max-count="1"
          :after-read="imgUpload" />
        <van-field
          v-model="editNav1Value.Title"
          label="标题"
          placeholder="请输入标题"
          required
          error />
      </van-cell-group>
    </van-dialog>

    <!-- 二级导航对话框 -->
    <van-dialog
      v-model="visableNav2Dialog"
      :title="editNav2Value && editNav2Value.Id ? '编辑' : '新增'"
      show-cancel-button
      @confirm="editNav2Confirm">
      <van-cell-group v-if="editNav2Value">
        <van-field
          v-model="editNav2Value.Title"
          required
          input-align="center"
          placeholder="请输入标题" />
      </van-cell-group>
    </van-dialog>

    <!-- 悬浮的保存按钮 -->
    <van-button
      size="small"
      icon="success"
      type="primary"
      round
      style="font-size: 14px; position: fixed; bottom: 50px; right: 20px"
      @click="savePage"
      >保存</van-button
    >

    <!-- 悬浮的保存按钮 -->
    <van-button
      icon="lock"
      size="small"
      :type="draggableLock ? 'danger' : 'warning'"
      round
      style="font-size: 14px; position: fixed; bottom: 90px; right: 20px"
      @click="draggableLock = !draggableLock"
      >{{ draggableLock ? '解锁排序' : '锁定排序' }}</van-button
    >

    <!-- 访问令牌 -->
    <van-dialog v-model="visableTokenDialog" @confirm="login">
      <van-field
        v-model="accessToken"
        rows="2"
        autosize
        type="textarea"
        placeholder="请输入令牌"
        style="height: 300px" />
    </van-dialog>
  </div>
</template>

<script>
const AES_KEY = 'A1DS3H6H9EW1DF1F' //G5SD3F4SD53F4SD5

import productItemVue from './productItem.vue'
import { generateId } from '@/utils.js'
import draggable from 'vuedraggable'
import oss from '@/utils/oss'
import { decrypt } from '@/utils/aes'

export default {
  name: 'product-list',
  components: {
    'product-item': productItemVue,
    draggable
  },
  props: {
    //商品数据
    productData: Array,
    shoppingCartData: {
      Type: Array,
      default: () => []
    }
  },
  data() {
    return {
      search: '',
      navObjLevel1: null,
      navActiveLevel1: null,
      navActiveLevel2: null,
      shoppingCart: this.shoppingCartData,
      visableEditDialog: false,
      visableNav1Dialog: false,
      visableNav2Dialog: false,

      // 商品编辑
      editProduct: null,
      editProductImgs: [],

      // 一级导航编辑
      editNav1Value: null,
      editNavImgs: [],

      // 二级导航编辑
      editNav2Value: null,

      // 商品信息
      products: this.productData,

      drag: false,
      dragNav1: false,
      dragNav2: false,

      // 访问令牌
      accessToken: '',
      ossConfig: null,
      visableTokenDialog: true,

      //锁定拖拽
      draggableLock: true
    }
  },
  computed: {
    navSelectedItemLevel2() {
      if (
        this.navObjLevel1 &&
        this.navObjLevel1.Items &&
        this.navObjLevel1.Items.length > 0 &&
        this.navActiveLevel2 !== null
      ) {
        return this.navObjLevel1.Items[this.navActiveLevel2]
      }
      return []
    },
    filterProducts: {
      get() {
        if (this.navSelectedItemLevel2 && this.navSelectedItemLevel2.Items) {
          return this.navSelectedItemLevel2.Items
        }
        return []
      },
      set(newValue) {
        this.navSelectedItemLevel2.Items = newValue
      }
    }
  },
  methods: {
    login() {
      try {
        let ossConfigStr = decrypt(AES_KEY, this.accessToken)
        console.log('ossConfigStr', ossConfigStr)
        this.ossConfig = JSON.parse(ossConfigStr)
        this.visableTokenDialog = false
      } catch {
        this.$toast('登录失败')
        setTimeout(() => {
          window.location.reload()
        }, 1500)
        return
      }
    },
    uploadFile(data, dir, name) {
      return oss.uploadFile(this.ossConfig, data, dir, name)
    },
    savePage() {
      //保存正确数据
      this.uploadFile(
        Buffer.from(JSON.stringify(this.products)),
        '',
        'products.json'
      )
      this.$toast('保存成功')

      //历史数据（用于数据复原）
      this.uploadFile(
        Buffer.from(JSON.stringify(this.products)),
        'productDataHistory',
        Date.now() + '_products.json'
      )
    },
    delNav1(nav) {
      this.$dialog
        .confirm({
          title: `确认要删除[${nav.Title}]吗`
        })
        .then((state) => {
          if (state === 'confirm') {
            let index = this.products.findIndex((v) => v === nav)
            this.products.splice(index, 1)
          }
        })
        .catch(() => {})
    },
    delNav2(nav) {
      this.$dialog
        .confirm({
          title: `确认要删除[${nav.Title}]吗`
        })
        .then((state) => {
          if (state === 'confirm') {
            let index = this.navObjLevel1.Items.findIndex((v) => v === nav)
            this.navObjLevel1.Items.splice(index, 1)
          }
        })
        .catch(() => {})
    },
    delProduct(product) {
      this.$dialog
        .confirm({
          title: `确认要删除商品[${product.Title}]吗?`
        })
        .then((state) => {
          if (state === 'confirm') {
            let index = this.navSelectedItemLevel2.Items.findIndex(
              (v) => v === product
            )
            this.navSelectedItemLevel2.Items.splice(index, 1)
          }
        })
        .catch(() => {})
    },
    editNav2Confirm() {
      if (!this.navObjLevel1) {
        console.log('未选中一级导航')
        return
      }
      if (!this.editNav2Value.Id) {
        this.navObjLevel1.Items.push(this.generateNewModel(this.editNav2Value))
      }
    },
    editNav1Confirm() {
      // 一级导航图片保存
      if (this.editNavImgs && this.editNavImgs.length > 0) {
        this.editNav1Value.Img = this.editNavImgs[0].url || '/img.png'
      } else {
        this.editNav1Value.Img = ''
      }

      // 首次新增一级导航
      if (!this.editNav1Value.Id) {
        this.products.push(this.generateNewModel(this.editNav1Value))
      }
    },
    editNav1(nav) {
      if (!nav) {
        nav = {
          Title: '',
          Img: '',
          Items: []
        }
      }

      if (nav.Img) {
        this.editNavImgs = [
          {
            url: nav.Img
          }
        ]
      } else {
        this.editNavImgs = []
      }

      this.visableNav1Dialog = true
      this.editNav1Value = nav
    },
    editNav2(nav) {
      if (!nav) {
        nav = {
          Title: '',
          Items: []
        }
      }
      this.visableNav2Dialog = true
      this.editNav2Value = nav
    },
    imgUpload(file) {
      file.status = 'uploading'
      file.message = '上传中...'

      const dir = 'productImgs'
      const name = `${Date.now()}.png`
      this.uploadFile(file.file, dir, name).then(() => {
        file.status = ''
        file.message = ''
        //上传后的url
        file.url = `${dir}/${name}`
      })
    },
    edit(product) {
      if (!product) {
        product = {
          Img: '',
          Title: '',
          Price: '',
          Label: ''
        }
      }
      this.editProduct = product
      if (product.Img) {
        this.editProductImgs = [
          {
            url: product.Img
          }
        ]
      } else {
        this.editProductImgs = []
      }

      this.visableEditDialog = true
    },
    editConfirm() {
      // 商品图片保存
      if (this.editProductImgs && this.editProductImgs.length > 0) {
        this.editProduct.Img = this.editProductImgs[0].url
      } else {
        this.editProduct.Img = ''
      }

      // 商品信息
      if (!this.editProduct.Id) {
        this.navSelectedItemLevel2.Items.push(
          this.generateNewModel(this.editProduct)
        )
      }
    },
    generateNewModel(data) {
      let newData = JSON.parse(JSON.stringify(data))
      newData.Id = generateId()
      return newData
    }
  },
  watch: {
    productData() {
      // 一级导航
      if (
        this.navActiveLevel1 === null &&
        this.productData &&
        this.productData.length > 0
      ) {
        this.navActiveLevel1 = 0
        this.navObjLevel1 = this.productData[this.navActiveLevel1]
      }
      //二级导航
      if (
        this.navActiveLevel2 === null &&
        this.navObjLevel1 &&
        this.navObjLevel1.Items.length > 0
      ) {
        this.navActiveLevel2 = 0
      }

      this.products = this.productData
    },
    navActiveLevel1() {
      this.navActiveLevel2 = 0
    }
  }
}
</script>

<style scoped>
#page {
  background-color: rgb(251, 251, 251);
}

.nav-level1 {
  font-size: 12px;
  height: 105px;
  overflow-x: scroll;
  white-space: nowrap;
  background-color: white;
}

.nav-level1 .selected {
  background-color: rgb(1, 102, 184);
  border-radius: 5px;
  padding: 2px 0;
  color: white;
}

.nav-item-level1 {
  width: 70px;
  height: 70px;
  padding: 5px 5px;
  display: inline-block;
  text-align: center;
  vertical-align: top;
}

.nav-item-level1 img {
  width: 60px;
  height: 60px;
  border-radius: 20px;
}

.nav-item-level1 span {
  background-color: aliceblue;
}

.content {
  margin-top: 10px;
  background-color: white;
  /* 搜索框55px 一级导航105px 内容间距10px 底部导航栏70px */
  height: calc(100vh - 55px - 105px - 10px - 70px);
  overflow-y: scroll;
}
.navLevel2 {
  height: 100%;
  overflow-y: scroll;
}
.search-box {
  height: 55px;
}
.product-list {
  height: 100%;
  overflow-y: scroll;
}
</style>
<style>
.van-sidebar-item--select::before {
  background-color: rgb(1, 102, 184) !important;
}
.van-sidebar-item--select .van-sidebar-item__text {
  font-weight: bold;
}
.van-search__content {
  border: 1px rgb(1, 102, 184) solid;
  border-radius: 5px !important;
}
.van-stepper--round .van-stepper__plus {
  background-color: #0166b8 !important;
}
.van-stepper--round .van-stepper__minus {
  border-color: #0166b8 !important;
  color: #0166b8 !important;
}
</style>
